export interface DemoSourceCatalogItem {
  id: string;
  name: string;
  provider: string;
  connected: boolean;
}

/** 11 connected + 5 available. Demo-mode only. */
export const DEMO_SOURCE_CATALOG: DemoSourceCatalogItem[] = [
  { id: 'demo-aws', name: 'AWS CloudTrail', provider: 'aws', connected: true },
  { id: 'demo-okta', name: 'Okta', provider: 'okta', connected: true },
  { id: 'demo-crowdstrike', name: 'CrowdStrike Falcon', provider: 'crowdstrike', connected: true },
  { id: 'demo-paloalto', name: 'Palo Alto Networks', provider: 'paloalto', connected: true },
  { id: 'demo-splunk', name: 'Splunk', provider: 'splunk', connected: true },
  { id: 'demo-fortinet', name: 'Fortinet', provider: 'fortinet', connected: true },
  { id: 'demo-zscaler', name: 'Zscaler', provider: 'zscaler', connected: true },
  { id: 'demo-azure', name: 'Microsoft Entra ID', provider: 'azure', connected: true },
  { id: 'demo-gcp', name: 'Google Cloud', provider: 'gcp', connected: true },
  { id: 'demo-servicenow', name: 'ServiceNow', provider: 'servicenow', connected: true },
  { id: 'demo-jira', name: 'Jira', provider: 'jira', connected: true },
  { id: 'demo-checkpoint', name: 'Check Point', provider: 'checkpoint', connected: false },
  { id: 'demo-sentinelone', name: 'SentinelOne', provider: 'sentinelone', connected: false },
  { id: 'demo-carbonblack', name: 'Carbon Black', provider: 'carbonblack', connected: false },
  { id: 'demo-cloudflare', name: 'Cloudflare', provider: 'cloudflare', connected: false },
  { id: 'demo-github', name: 'GitHub', provider: 'github', connected: false },
];
